import React, { useState, useEffect } from 'react';
import styles from './RequestsHint.module.scss';
import { Hint } from '../Hint/Hint';
import { useSelector, useDispatch } from 'react-redux';
import { OldRequest } from './components/OldRequest/OldRequest';
import { Button } from 'antd';
import { actions } from '../../../../../CreateRequest/new-request.actions';

const FILTER_TYPES = {
  ACTUAL: 'actual',
  COMPLETED: 'completed',
};

export const RequestsHint = ({
  setVisible,
  visible,
  canChangeVisibleRequests,
}) => {
  const oldRequests = useSelector((state) => state.newRequestStore.oldRequests);

  const dispatch = useDispatch();

  const { valueAddrFlat: addressId } = useSelector(
    (state) => state.newRequestStore
  );

  useEffect(() => {
    if (visible && canChangeVisibleRequests && addressId) {
      dispatch(actions.fetchGetOldRequests(addressId));
    } else {
      dispatch(actions.clearOldRequests());
    }
  }, [visible, canChangeVisibleRequests, addressId]);

  const ACTUAL_STATUSES = [
    'Новая',
    'В работе',
    'Выполнена',
    'Выполнена(контроль качества)',
  ];
  const COMPLETED_STATUSES = ['Закрыта', 'Аннулирована'];

  const [filter, setFilter] = useState(null);

  let filteredRequests = oldRequests?.requests || [];
  if (filter === FILTER_TYPES.ACTUAL) {
    filteredRequests = filteredRequests.filter((item) =>
      ACTUAL_STATUSES.includes(item.stateName)
    );
  } else if (filter === FILTER_TYPES.COMPLETED) {
    filteredRequests = filteredRequests.filter((item) =>
      COMPLETED_STATUSES.includes(item.stateName)
    );
  }
  filteredRequests = filteredRequests.sort(
    (a, b) => new Date(b.createDate) - new Date(a.createDate)
  );

  const handleFilterClick = (type) => {
    setFilter((prev) => (prev === type ? null : type));
  };

  return (
    <Hint
      setVisible={setVisible}
      title="Заявки"
      render={() => {
        return (
          <>
            <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
              <Button
                onClick={() => handleFilterClick(FILTER_TYPES.ACTUAL)}
                type={filter === FILTER_TYPES.ACTUAL ? 'primary' : 'default'}
              >
                Актуальные
              </Button>
              <Button
                onClick={() => handleFilterClick(FILTER_TYPES.COMPLETED)}
                type={
                  filter === FILTER_TYPES.COMPLETED ? 'primary' : 'default'
                }
              >
                Завершённые
              </Button>
            </div>
            <ul className={styles.root}>
              {filteredRequests && filteredRequests.length ? (
                filteredRequests.map((item) => (
                  <OldRequest
                    createUser={item.createUser}
                    garanty={item.garanty}
                    stateName={item.stateName}
                    typeRequest={item.typeRequest}
                    isChargeable={item.isChargeable}
                    isInternal={item.isInternal}
                    isRetry={item.isRetry}
                    isImmediate={item.isImmediate}
                    createDate={item.createDate}
                    executeDate={item.executeDate}
                    key={item.id}
                    id={item.id}
                    parentServiceName={item.parentServiceName}
                    serviceName={item.serviceName}
                  />
                ))
              ) : (
                <div className={styles.noRequests}>
                  Заявок по данному адресу не поступало
                </div>
              )}
            </ul>
          </>
        );
      }}
    />
  );
};
